import {
  apiGermanLocalization,
  apiEnglishLocalization
} from '@/features/api/localization/apiLocalization';
import {
  authGermanLocalization,
  authEnglishLocalization
} from '@/features/authorization/localization/authLocalization';
import {
  chatsGermanLocalization,
  chatsEnglishLocalization
} from '@/features/chats/localization/chatsLocalization';
import {
  experimentsGermanLocalization,
  experimentsEnglishLocalization
} from '@/features/experiments/localization/experimentsLocalization';
import {
  featureManagementGermanLocalization,
  featureManagementEnglishLocalization
} from '@/features/feature-management/localization/featureLocalization';
import {
  flagGermanLocalization,
  flagEnglishLocalization
} from '@/features/flag/localization/flagLocalization';
import {
  geoAreaGermanLocalization,
  geoAreaEnglishLocalization
} from '@/features/geo-area/localization/geoAreaLocalization';
import {
  groupsGermanLocalization,
  groupsEnglishLocalization
} from '@/features/groups/localization/groupsLocalization';
import {
  mediaGermanLocalization,
  mediaEnglishLocalization
} from '@/features/media/localization/mediaLocalization';
import {
  myPlaceGermanLocalization,
  myPlaceEnglishLocalization
} from '@/features/mein-ort/localization/myPlaceLocalization';
import {
  postCreationGermanLocalization,
  postCreationEnglishLocalization
} from '@/features/post-editor/localization/postCreationLocalization';
import {
  postEditorGermanLocalization,
  postEditorEnglishLocalization
} from '@/features/post-editor/localization/postEditorLocalization';
import {
  postsGermanLocalization,
  postsEnglishLocalization
} from '@/features/posts/localization/postsLocalization';
import {
  privacyGermanLocalization,
  privacyEnglishLocalization
} from '@/features/privacy/localization/privacyLocalization';
import {
  organizationEnglishLocalization,
  organizationGermanLocalization
} from '@/features/profile-setting/localization/organizationLocalization';
import {
  profileSettingsGermanLocalization,
  profileSettingsEnglishLocalization
} from '@/features/profile-setting/localization/profileSettingsLocalization';
import {
  senderSelectionGermanLocalization,
  senderSelectionEnglishLocalization
} from '@/features/sender-selection/localization/senderSelectionLocalization';
import {
  startGermanLocalization,
  startEnglishLocalization
} from '@/features/start/localization/startLocalization';
import {
  tutorialGermanLocalization,
  tutorialEnglishLocalization
} from '@/features/tutorial/localization/tutorialLocalization';
import {
  verificationGermanLocalization,
  verificationEnglishLocalization
} from '@/features/verification/localization/verificationLocalization';
import {
  Locale,
  LocalizationNameSpace
} from '@/localization/types/localizationTypes';
import {
  navigationGermanLocalization,
  navigationEnglishLocalization
} from '@/navigation/localization/navigationLocalization';
import {
  sharedGermanLocalization,
  sharedEnglishLocalization
} from '@/shared/localization/sharedLocalization';

export const localizationResources = {
  [Locale.DE]: {
    [LocalizationNameSpace.AUTHORIZATION]: authGermanLocalization,
    [LocalizationNameSpace.NAVIGATION]: navigationGermanLocalization,
    [LocalizationNameSpace.GEO_AREA]: geoAreaGermanLocalization,
    [LocalizationNameSpace.MY_PLACE]: myPlaceGermanLocalization,
    [LocalizationNameSpace.PROFILE_SETTING]: profileSettingsGermanLocalization,
    [LocalizationNameSpace.ORGANIZATION]: organizationGermanLocalization,
    [LocalizationNameSpace.SHARED]: sharedGermanLocalization,
    [LocalizationNameSpace.PRIVACY]: privacyGermanLocalization,
    [LocalizationNameSpace.POSTS]: postsGermanLocalization,
    [LocalizationNameSpace.POST_EDITOR]: postEditorGermanLocalization,
    [LocalizationNameSpace.POST_CREATION]: postCreationGermanLocalization,
    [LocalizationNameSpace.SENDER_SELECTION]: senderSelectionGermanLocalization,
    [LocalizationNameSpace.GROUPS]: groupsGermanLocalization,
    [LocalizationNameSpace.EXPERIMENTS]: experimentsGermanLocalization,
    [LocalizationNameSpace.FEATURE_MANAGEMENT]:
      featureManagementGermanLocalization,
    [LocalizationNameSpace.MEDIA]: mediaGermanLocalization,
    [LocalizationNameSpace.VERIFICATION]: verificationGermanLocalization,
    [LocalizationNameSpace.CHATS]: chatsGermanLocalization,
    [LocalizationNameSpace.START]: startGermanLocalization,
    [LocalizationNameSpace.FLAGS]: flagGermanLocalization,
    [LocalizationNameSpace.TUTORIAL]: tutorialGermanLocalization,
    [LocalizationNameSpace.API]: apiGermanLocalization
  },
  [Locale.EN]: {
    [LocalizationNameSpace.AUTHORIZATION]: authEnglishLocalization,
    [LocalizationNameSpace.NAVIGATION]: navigationEnglishLocalization,
    [LocalizationNameSpace.GEO_AREA]: geoAreaEnglishLocalization,
    [LocalizationNameSpace.MY_PLACE]: myPlaceEnglishLocalization,
    [LocalizationNameSpace.PROFILE_SETTING]: profileSettingsEnglishLocalization,
    [LocalizationNameSpace.ORGANIZATION]: organizationEnglishLocalization,
    [LocalizationNameSpace.SHARED]: sharedEnglishLocalization,
    [LocalizationNameSpace.PRIVACY]: privacyEnglishLocalization,
    [LocalizationNameSpace.POSTS]: postsEnglishLocalization,
    [LocalizationNameSpace.POST_EDITOR]: postEditorEnglishLocalization,
    [LocalizationNameSpace.POST_CREATION]: postCreationEnglishLocalization,
    [LocalizationNameSpace.SENDER_SELECTION]:
      senderSelectionEnglishLocalization,
    [LocalizationNameSpace.GROUPS]: groupsEnglishLocalization,
    [LocalizationNameSpace.EXPERIMENTS]: experimentsEnglishLocalization,
    [LocalizationNameSpace.FEATURE_MANAGEMENT]:
      featureManagementEnglishLocalization,
    [LocalizationNameSpace.MEDIA]: mediaEnglishLocalization,
    [LocalizationNameSpace.VERIFICATION]: verificationEnglishLocalization,
    [LocalizationNameSpace.CHATS]: chatsEnglishLocalization,
    [LocalizationNameSpace.START]: startEnglishLocalization,
    [LocalizationNameSpace.FLAGS]: flagEnglishLocalization,
    [LocalizationNameSpace.TUTORIAL]: tutorialEnglishLocalization,
    [LocalizationNameSpace.API]: apiEnglishLocalization
  }
};
